@import (reference) '../../../../../../constants/spacing.module.less';

.apply-insurance-radio-section {
  padding-top: @space-16;
  margin-top: @space-16;
  border-top: 1px solid var(--grey-300);
}

.apply-insurance-radio-label {
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
}

.radio-list {
  margin-top: @space-12;
}

.radio-option-description {
  color: var(--grey-700);
  font-size: 14px;
  margin-top: @space-4;
  margin-left: @space-24;
}

.active-parcel-guard-rules-banner {
  margin-top: @space-12;
  border-radius: @space-8;
}

.active-parcel-guard-rules-banner a {
  color: var(--blue-600);
  text-decoration: none;
}

.active-parcel-guard-rules-banner a:hover {
  text-decoration: underline;
}

.skip-with-active-rules-warning {
  margin-top: @space-12;
  border-radius: @space-8;
}
